export default {
    patentReview: {
        documentPane: {
            page: '第 {current} / {total} 頁',
            previousPage: '上一頁',
            nextPage: '下一頁',
            'document': '待核稿檔案',
            'readOnly': '唯讀',
            'localFile': '本機預覽',
            'original': '原始文件',
            'text': '解析原文',
            'textHint': '解析原文用於核對和定位，不保留原檔案版式。',
            'zoomIn': '放大',
            'zoomOut': '縮小',
            'loading': '正在載入文件…',
            'unsupported': '此格式暫不支援原版預覽，可查看解析原文。Word 原版預覽支援 DOCX。',
            'failed': '原檔案載入失敗，可重試或查看解析原文。',
            'noFile': '尚無可預覽的原檔案，可選擇本機 Word / PDF，僅在瀏覽器中預覽，不會上傳或替換任務檔案。',
            'retry': '重試',
            'unresolved': '暫時無法精確定位，請結合右側問題與原文核對。',
            'missingInsertion': '缺失內容應補充在此處',
            'empty': '尚無解析內容',
        },
        results: {
            'results': '核稿結果',
            'sort': '結果排序',
            'importance': '按重要程度',
            'document': '按文章內順序',
            'figureOrder': '按附圖內順序',
            'passed': '通過',
            'failed': '不通過',
            'manual': '需人工確認',
            'ignore': '忽略',
            'confirm': '確認',
            'ignored': '已忽略',
            'confirmed': '已確認',
            'summary': '核稿結果統計',
            'ruleName': '規則名',
            'unnamedRule': '未命名規則',
            'expand': '展開',
            'collapse': '收起',
            'status': '狀態',
            'rule': '檢查規則',
            'reason': '錯誤理由',
            'explanation': '結果說明',
            'suggestion': '修改建議',
            'location': '具體位置',
            'system': '系統規則',
            'custom': '自訂規則',
            'ruleUnavailable': '暫無規則原文',
            'locationUnavailable': '暫無可定位原文',
            'orderHint': '按已解析章節及原文位置排序；缺少位置的記錄保留章節順序。',
            'figureOrderHint': '按目前附圖內的檢查位置排序；缺少位置信息的記錄保留檢查順序。',
        },
        figurePane: {
            workspace: '附圖核對工作區', readOnly: '唯讀', recognizedCount: '已識別 {count} 個圖幅', figure_overview: '逐圖核稿', abstract_drawing: '摘要附圖',
            combinedReview: '附圖核稿', abstractDrawing: '摘要附圖',
            drawingNavigator: '附圖導航', drawingTotal: '共 {count} 幅', collapseNavigator: '收起', expandNavigator: '展開', drawingRange: '第 {start}–{end} 幅',
            matrixTitle: '逐圖核稿狀態', presenceCheck: '不缺失', visualCheck: '圖內合規', claimsCheck: '權利要求一致性', specificationCheck: '說明書一致性',
            presenceShort: '存在', visualShort: '圖內', claimsShort: '權要', specificationShort: '說明書',
            checkStatus_pass: '通過', checkStatus_fail: '不通過', checkStatus_manual: '需確認', checkStatus_pending: '待檢測', numberNeedsConfirmation: '圖號待確認',
            previousDrawing: '上一幅', nextDrawing: '下一幅', drawingPosition: '第 {current} / {total} 幅', drawingReviewTitle: '{drawing}核稿',
            missingFigure: '圖幅缺失', missingFigureHint: '文字中提到了圖{number}，但沒有識別到對應圖片。', abstractCandidates: '摘要附圖候選',
            recognitionUnavailable: '尚無附圖識別結果', recognitionUnavailableHint: '無法確認是否存在附圖，也不會將本步驟判定為通過。',
            figureNo: '圖{number}', unknownFigure: '未識別圖號 · 第{number}幅', noFigures: '沒有識別到附圖', noFiguresHint: '請先確認申請是否應包含附圖，並按需補齊文件。',
            notFound: '未找到', previewPending: '目前接口暫未提供單幅圖片預覽', noDescription: '暫無圖面識別描述', referenceSigns: '已識別附圖標記', noReferenceSigns: '未識別到附圖標記',
            abstractText: '摘要正文', noAbstract: '未識別到摘要正文', abstractCandidateHint: '目前版本展示候選圖幅和摘要內容；摘要附圖的明確選擇仍以核稿結果為準。',
            confidence_high: '圖號可信度高', confidence_medium: '圖號由模型推斷', confidence_low: '圖號待確認', source_caption_regex: '來自原文圖號', source_vision_match: '來自圖文匹配', source_unknown: '圖號來源未知',
        },
        workflow: {
            incompleteFileTitle: '文件內容不完整',
            skipMissingNotice: '接下來將跳過以下內容的檢測：{sections}。如需完整核稿，請先補齊文件。',
            fileChecklist: '文件內容清單',
            notRecognized: '未識別到',
            missingSection: '未識別到{section}，後續將不檢測{section}。',
            unconfirmedSection: '尚未確認是否識別到{section}，請核對原文並按需補齊。',
            supplementSection: '補齊文件：{section}',
            replaceSupplement: '更換文件',
            supplementPending: '待提交 · 文件僅暫存在目前頁面，尚未加入本次核稿。',
            invalidSupplement: '請選擇非空的 Word、PDF、TXT 或圖片文件。',
            reviewCount: '{count} 條記錄需複核',
            noConclusion: '尚無總體結論，請查看各部分結果。',
            claimsMaterial: '權利要求',
            specificationMaterial: '說明書',
            'detection': '檔案檢測',
            'claims': '權利要求核稿',
            'specification': '說明書核稿',
            'figures': '附圖核稿',
            'report': '核稿結果',
            'title': '標題',
            'technical_field': '技術領域',
            'background': '背景',
            'summary': '發明內容',
            'detailed_description': '具體實施方式',
            'abstract': '摘要',
            'drawings': '附圖',
            'drawings_description': '附圖說明',
            'abstract_drawing': '摘要附圖',
            'unclassified': '跨部分／未歸類',
            'all': '全部結果',
            'waiting': '等待結果',
            'partial': '部分結果可查看',
            'available': '結果可查看',
            'failed': '執行中斷',
            'source': '原文與材料',
            'detected': '已識別',
            'unconfirmed': '待確認',
            'detecting': '識別中',
            'figureFound': '已識別 {count} 張附圖，適用性待確認',
            'figureEmpty': '未識別到附圖，是否需要補齊待確認',
            'figureUnknown': '尚無附圖識別結果，不能判定不適用',
            'optional': '可選材料，不阻斷申請核稿',
            'disclosure': '技術交底材料',
            'supplement': '補齊檔案',
            'supplementHint': '目前任務暫不支援追加材料。請回到首頁，重新上傳完整材料並建立新任務。',
            'newTask': '返回首頁重新上傳',
            'close': '關閉',
            'reviewHint': '結果按文件部分整理。部分結果可查看時，後續檢查仍可能補充問題。',
            'scopeHint': '未能確定所屬部分的結果保留在下方，請一併複核。',
            'empty': '目前範圍暫無檢查記錄，不代表已檢查通過。',
            'noSource': '尚無可展示的原文，請查看檔案檢測結果。',
            'sourceWhole': '以下為完整說明書原文，具體子章節以問題定位為準。',
            'confirmDetection': '確認',
            'locate': '定位原文',
            'basis': '判斷依據',
            'suggestion': '修改建議',
            'boundary': '適用邊界',
            'notAssessed': '未完成判斷',
            'pass': '通過',
            'issue': '需複核',
            'retry': '重新載入結果',
            'loadFailed': '結果載入失敗，請重試。',
            'detectionHint': '檢測各部分是否齊備、可解析；附圖適用性與完整性也屬於本環節。識別到內容不代表檢查通過。',
            'pendingApplicability': '適用性待確認',
            'export': '匯出報告',
            'reportPending': '報告尚未產生，可先查看已返回的各部分結果。',
        },
        entry: {
            materials: '核稿材料',
            applicationReview: '專利申請',
            description: '上傳待核稿的申請文件，按需補充參考材料。',
            required: '必選',
            optional: '可選',
            choose: '選擇文件',
            replace: '替換文件',
            remove: '移除 {name}',
            targetLabel: '申請文件',
            targetHint: '上傳一份完整的專利申請稿，支援 Word、PDF，可拖入文件',
            supportingLabel: '其他技術材料',
            supportingHint: '上傳多份用於核對技術一致性的文件，支援 Word、PDF、TXT、JPG、PNG',
            disclosureLabel: '技術交底材料',
            disclosureHint: '用於核對技術內容與申請稿的一致性 · Word / PDF / TXT',
            otherLabel: '其他材料',
            otherHint: '目前支援附圖材料 · PDF / JPG / PNG',
            unsupportedFormat: '此材料不支援該文件格式，請依提示選擇。',
            tooManyFiles: '申請文件與輔助材料合計最多 10 個文件。',
            oneTarget: '請提供一份完整申請文件。',
            fileCount: '已選 {count}/10 個文件',
            start: '開始核稿',
            submitting: '正在提交…',
            rules: '規則庫',
            selectedLibraries: '{office} · {count} 個規則庫',
            libraryHint: '由所選系統庫決定受理局，可加入同一受理局的自訂規則庫。',
            taskCreated: '核稿任務已建立',
            ruleDialog: '選擇規則庫',
            ruleScopeHint: '選擇一個系統庫，可加入同一受理局的自訂庫。切換系統庫會移除其他受理局的已選庫。',
            selectionRequired: '請選擇有效系統庫；自訂庫須與其受理局一致。',
            libraryLoadFailed: '規則庫載入失敗，請關閉後重試。',
        },
        list: {
            title: '核稿任務',
            empty: '暫無核稿任務',
            emptyHint: '上傳專利初稿檔案，即可開始形式核稿',
            rules: '條規則',
            tabTasks: '核稿任務列表',
            tabRules: '規則庫',
        },
        status: {
            pending: '待處理',
            running: '執行中',
            completed: '已完成',
            failed: '失敗',
        },
        steps: {
            '1_parsing': '解析檔案',
            '2_extracting': '提取四要素',
            '3_figure_analysis': '附圖分析',
            '4_formal_check': '形式核稿',
            '5_finalizing': '匯總報告',
        },
        stepStatus: {
            done: '已完成',
            running: '執行中',
            failed: '失敗',
            pending: '等待中',
        },
        upload: {
            customRulesSection: {
                dialogTitle: '規則庫',
                searchPlaceholder: '搜尋規則庫名稱',
                customGroup: '自定義規則庫',
                newGroup: '本次新上傳',
                uploadButton: '上傳規則',
                uploadFormats: '支援 .docx / .pdf / .pptx',
                confirm: '確認選擇',
                confirmSelection: '確認',
                empty: '暫無規則庫，點擊「上傳規則」新增',
                rulesEmpty: '該規則庫未提取出規則',
                loadFailed: '加載規則庫列表失敗，請重試',
                uploadFailed: '上傳規則檔案失敗，請重試',
                tableIndex: '序號',
                tableSection: '核稿部分',
                tableIssueDesc: '問題描述',
            },
            patentType: {
                label: '專利類型',
                invention: '發明',
                utility: '實用新型',
            },
            cancel: '取消',
        },
        detail: {
            backToList: '返回列表',
            taskHeader: {
                entry: '核稿審查',
                projectPackage: '專利審查項目包',
                unnamedTask: '未命名任務',
                progressTitle: '審查進度',
                autoRun: '自動運行',
                exportReport: '導出報告',
                exportNotReady: '核稿完成後可導出',
                finalizingCardSubtitle: '匯總結論',
                stepsExecutedCaption: '三項流程已執行',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 項問題',
            },
            materials: {
                mainFileTag: '專利申請檔案',
                figureTag: '附圖',
                disclosureTag: '交底書',
                attachmentTag: '附件',
            },
            parsing: {
                fileName: '檔案名',
                fileNamePending: '正在識別主檔案…',
                hint: '正在解析上傳檔案的文本內容…',
                inspectionSummary: '已定位 {located}/{total} 個內容部分',
                characterCount: '{count} 字',
                locate: '定位',
                missing: '未識別到內容',
                documentType: {
                    patent_application: '專利申請文件',
                    disclosure: '技術交底材料',
                    office_action: '審查意見通知書',
                    unknown: '文件類型待確認',
                },
            },
            extracting: {
                title: '發明名稱',
                technical_field: '技術領域',
                background: '背景技術',
                summary: '發明內容',
                drawings_description: '附圖說明',
                detailed_description: '具體實施方式',
                abstract: '摘要',
                claims: '權利要求書',
                specification: '說明書',
                figures: '附圖',
                expand: '展開',
                collapse: '收起',
                empty: '暫無內容',
            },
            check: {
                pass: '通過',
                passCollapsed: '通過（{count} 條）',
                filterAll: '全部',
                filterInfo: '提示',
                filterWarning: '警告',
                filterError: '錯誤',
                filterCritical: '嚴重',
                location: '位置',
                suggestion: '修改建議',
                guidelineSource: '依據來源',
                empty: '暫無形式核稿問題',
                summaryPattern: '發現 {count} 處可定位的形式或企業規範問題',
                statTitle: '發現{count}處形式問題，其中，{officialCount}項違反官方規則，{customCount}項違反企業規則。',
                statFormalIssues: '形式問題',
                statOfficialViolations: '違反官方規則',
                statCustomViolations: '違反企業規則',
                summaryTitle: '形式檢查·總結結論',
                summaryError: '{count}項錯誤',
                summaryWarning: '{count}項不符合規範',
                summaryRequireConfirm: '{count}項需人工確認',
                summaryStats: '共{total}條規則·{error}項·{warning}項·{requireConfirm}項·{pass}項已通過',
                systemRules: '系統規則',
                customRules: '企業規則',
                legendPass: '通過',
                legendFail: '不通過',
                legendPending: '需人工確認',
                summaryAllPassed: '全部通過',
                coverageTitle: '規則覆蓋',
                coverageSource: '規則來源',
                coverageTotal: '規則數',
                coverageFail: '不通過',
                coverageVerify: '待確認',
                coveragePending: '待核查',
                coveragePassed: '通過',
            },
            table: {
                tabIssues: '問題定位表',
                tabCoverage: '檢查覆蓋',
                sourceOfficial: '官方規則',
                sourceCustom: '企業規則',
                sourceCustomEmpty: '暫無企業自定義規則命中數據',
                searchPlaceholder: '搜索權項、問題或法條',
                columnIndex: '#',
                columnLocation: '具體位置',
                columnIssue: '檢查結果/問題',
                columnStatute: '適用法條/規則依據',
                columnSuggestion: '修改建議',
                columnEvidence: '證據',
                evidenceEmpty: '—',
                statusPending: '需修改',
                statusApplied: '已修改',
                statusIgnored: '已忽略',
                statusPass: '已通過',
                coverageColumnType: '規則類型',
                coverageColumnRule: '檢查規則',
                coverageColumnContent: '規則內容',
                coverageColumnResult: '檢查結果',
                coverageResultEmpty: '—',
                coverageResultFound: '發現問題',
                ruleTypeOfficial: '官方規則',
                ruleTypeCustom: '企業規則',
                itemUnit: '項',
                columnPatentSection: '專利章節',
                columnCheckRule: '檢查規則',
                columnCheckResult: '檢查結果',
                columnErrorReason: '錯誤理由',
                editButton: '編輯',
                adoptButton: '採納改文',
                locateButton: '錯誤定位',
                locationModalTitle: '錯誤定位',
                locationModalContent: '定位信息：{location}',
                locationModalClose: '關閉',
                locationModalRuleLabel: '檢查規則',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修改建議',
                locationModalBoundaryLabel: '適用邊界',
                locationModalSourceTitle: '原稿內容',
                locationModalPositionUnresolved: '未能確定錯誤位置',
                statusRequireModify: '需修改',
                statusRequireConfirm: '需人工確認',
                statusPendingVerification: '待核查',
            },
            finalizing: {
                reportTitle: '專利核稿報告',
                reportSubtitle: '一種自適應多級阻尼緩沖器',
                conclusion: '總體結論',
                totalRules: '規則總數',
                passCount: '通過',
                warningCount: '警告',
                errorCount: '錯誤',
                criticalCount: '嚴重錯誤',
                conclusions: {
                    formal: '形式核稿結論',
                    art26_3: '第26條第3款結論',
                    art26_4: '第26條第4款結論',
                },
                riskMatrix: {
                    title: '實質核稿風險等級分布',
                    high: '高風險',
                    medium: '中風險',
                    low: '低風險',
                },
                conclusionValue: {
                    compliant: '符合',
                    risky: '基本符合但有風險',
                    non_compliant: '可能不符合',
                    insufficient: '材料不足無法完整判斷',
                },
                dimensionConclusions: {
                    title: '檢查維度結論',
                    unresolved: '未判定',
                },
                reportMeta: {
                    office: '受理局',
                    applicationType: '申請類型',
                    invention: '發明',
                    reportDate: '報告日期',
                    summaryTitle: '報告摘要',
                    summaryDefault: '優先修正明確的形式問題，並核實引用的可達性指向；保護範圍與公開依據的需核實；擬增加的限定範圍評估指向影響，完成修改與材料核實重新核稿。',
                    checkModule: '檢查模組',
                    currentConclusion: '當前結論',
                    coverageScope: '覆蓋範圍',
                    formalCheck: '形式核稿',
                    substantiveCheck: '實質核稿',
                },
                formalCheckDetail: {
                    title: '形式問題明細',
                    ruleSource: '規則來源',
                    ruleCount: '規則數',
                    failed: '不通過',
                    needConfirm: '待確認',
                    passed: '通過',
                    pending: '待核查',
                    systemRules: '系統規則',
                    customRules: '自訂規則',
                    note1: '下表顯示已有發現；其餘規則保留待核查狀態，待確認、待核查且不代表通過。',
                    note2: '原文需通過標註需要修改或標註「待做」不作編正修改處理。',
                    location: '原文與位置',
                    conclusion: '結論與風險',
                    suggestion: '修改建議與邊界',
                },
            },
            featureMapping: {
                figuresNone: '本申請未包含附圖',
                figuresFailed: '附圖識別未完成，本次判斷未結合附圖內容',
                figureNoLabel: '圖{no}',
                figureNoUnknown: '圖號未標註',
                figureConfidenceMedium: '圖號為推斷結果',
                figureConfidenceLow: '圖號無法確定',
                figureSignsLabel: '圖面標引',
                figureNoSigns: '圖面未見標引',
            },
            substantive: {
                filterHigh: '高風險',
                filterMedium: '中風險',
                filterLow: '低風險',
                filterAll: '全部',
                needsInventorConfirm: '需發明人確認',
                boundaryLabel: '適用邊界',
                summaryPattern: '發現 {count} 處實質性問題，建議逐項核實',
                issuesLocations: '形式問題定位',
                title: '實質核稿',
                checkResultTitle: '檢查結果',
                issuesCount: '實質問題',
                highRiskCount: '高風險問題',
            },
            supplement: {
                title: '必要補充材料清單',
                columns: {
                    content: '需補充內容',
                    reason: '原因',
                    targetStatute: '用於解決的法條問題',
                    suggestedLocation: '建議補充位置',
                },
                empty: '暫無必要補充材料',
            },
            failed: {
                retryHint: '核稿任務執行失敗，可返回列表重新上傳檔案',
            },
            reportLoadFailed: {
                message: '加載核稿報告失敗，請重試',
                retry: '重新加載',
            },
            stepRunning: '該步驟正在執行，完成後可查看結果…',
            noStepSelected: '請選擇一個步驟查看詳情',
        },
        customRuleDocuments: {
            delete: '刪除',
            edit: '編輯',
            deleteConfirm: '確認刪除？',
            confirmYes: '確認',
            confirmNo: '取消',
            empty: '暫無規則文檔',
            applicableScopeLabelText: '適用範圍',
            sourceLabel: '規則來源',
            table: {
                name: '規則庫名稱',
                office: '地區',
                field: '技術領域',
                rulesCount: '規則數',
                updatedAt: '最近更新',
                actions: '操作',
                enabled: '啟用',
            },
            rulesEmpty: '該文檔未提取出規則',
            rulesLoadFailed: '加載規則明細失敗，請重試',
            rulesCount: '{count} 條規則',
            status: {
                uploaded: '已上傳',
                parsing: '解析中',
                parsed: '已解析',
                parse_failed: '解析失敗',
            },
            upload: {
                title: '上傳規則文檔',
                addButton: '上傳規則文檔',
                fileTitle: '上傳規則文檔',
                fileHint: 'PDF、DOCX',
                chooseFile: '選擇檔案',
                removeFile: '移除',
                confirm: '開始上傳',
                uploading: '正在上傳…',
                nameLabel: '規則庫名稱',
                namePlaceholder: '不填則使用檔案名稱',
                patentOfficeLabel: '地區',
                technicalFieldLabel: '技術領域',
            },
            technicalFieldOptions: {
                Common: '通用',
                Mechanical: '機械',
                Electrical: '電子',
                Chemical: '化學',
            },
            loadFailed: '加載規則文檔失敗，請重試',
            uploadFailed: '上傳規則文檔失敗，請重試',
            updateFailed: '更新失敗，請重試',
            deleteSuccess: '刪除成功',
            deleteFailed: '刪除失敗，請重試',
            editDrawer: {
                title: '編輯規則庫',
                save: '儲存',
                saving: '儲存中…',
                backToList: '返回列表',
            },
            detail: {
                loadFailed: '加載規則庫失敗，請重試',
            },
            import: '匯入檔案',
            importSuccess: '檔案匯入成功，正在解析規則…',
            importFailed: '檔案匯入失敗，請重試',
            parseCompleted: '規則解析完成',
            parseTimeout: '規則解析中，請稍後手動重新整理',
            parseFailed: '規則解析失敗',
            parseError: '檔案格式錯誤或不支援',
            selectedLabel: '已選 {count} 個規則庫 · {rules} 條規則',
        },
        customRule: {
            addRule: '新增規則',
            addFromTemplate: '從模板添加',
            editRule: '編輯規則',
            editRuleDescription: '把檢查條件寫具體，讓規則更容易被正確執行。',
            enabled: '啟用',
            allRules: '全部規則',
            patentSection: '核稿部分',
            patentSectionPlaceholder: '請選擇核稿部分',
            patentSectionTitle: '發明名稱',
            patentSectionField: '技術領域',
            patentSectionBackground: '背景技術',
            patentSectionSummary: '發明內容',
            patentSectionClaims: '權利要求書',
            patentSectionSpecification: '說明書及附圖',
            patentSectionImplementation: '具體實施方式',
            patentSectionAbstract: '摘要',
            patentSectionSpecificationOnly: '說明書',
            patentSectionFullText: '全文',
            problemDescription: '問題描述',
            problemDescriptionPlaceholder: '請輸入問題描述',
            problemDescriptionTip: '寫法建議：明確查對象 + 描述觸發條件，避免只寫「表述不規範」。',
            alertType: '提醒類型',
            severityInfo: '提示',
            severityWarning: '一般',
            severityError: '重點',
            problemDescriptionRequired: '問題描述不能為空',
            problemDescriptionMinLength: '問題描述至少需要 10 個字元',
            addRuleDialog: {
                title: '添加規則',
                subtitle: '從模板或已有文件中添加，現有規則會保留。',
                templateOption: '使用規則模板',
                templateOptionHint: '從常用核稿清單開始',
                importOption: '導入已有文件',
                importOptionHint: 'Word / Excel / PDF / PPT',
                chooseTemplate: '選擇規則模板',
                chooseTemplateHint: '先選一套接近你的核稿標準的模板，下一步可以逐條修改。',
                templateCount: '{count} 個模板',
                ruleCount: '{count} 條規則',
                coveredSections: '包含檢查項',
                importFileTitle: '上傳規則文件',
                importFileHint: 'Word、Excel、PDF、PPT',
                chooseFile: '選擇文件',
                removeFile: '移除',
                confirm: '儲存',
                submitting: '正在加入…',
            },
        },
        customRuleLibraries: {
            custom: '自訂規則',
            title: '規則庫',
            newLibrary: '+ 新增規則庫',
            total: '共 {count} 個規則庫',
            previous: '上一頁',
            next: '下一頁',
            selectPlaceholder: '請選擇',
            clearFilters: '清除篩選',
            searchPlaceholder: '搜尋規則庫名稱',
            gridView: '網格視圖',
            listView: '列表視圖',
            all: '全部',
            domains: {
                Common: '通用',
                Mechanical: '機械',
                Electrical: '電子',
                Chemical: '化學',
            },
            patentOffice: '受理局',
            system: '系統',
            systemLibraryName: '{office} 系統規則庫',
            createDialogTitle: '新增規則庫',
            ruleNameLabel: '規則庫名稱',
            ruleNamePlaceholder: '請輸入規則庫名稱',
            domainLabel: '技術領域',
            create: '建立',
            createSuccess: '規則庫已建立',
            createFailed: '建立失敗，請重試',
            editDialogTitle: '編輯規則庫',
            noRules: '尚無自訂規則庫',
            noRulesDesc: '點擊「新增規則庫」建立你的第一個規則庫',
        },
        catalog: {
            offices: {
                CNIPA: 'CNIPA',
                EPO: 'EPO',
                USPTO: 'USPTO',
                PCT: 'PCT',
            },
            enabled: '已啟用',
            loading: '載入中...',
            error: '載入失敗',
            retry: '重試',
            empty: '暫無資料',
            formalRules: '形式規則',
            substantiveDimensions: '實質維度',
            executionPass: '檢查通過',
            executionTriggered: '命中問題',
            suggestionLabel: '建議',
            visionUnsupported: '該規則依賴附圖分析結果，暫不支持單獨執行',
            noDocumentSelected: '請先選擇文檔',
            executeCheckFailed: '執行檢查失敗，請重試',
            table: {
                ruleId: '規則編號',
                category: '類別',
                severity: '嚴重程度',
                keyPoint: '要點',
                patentSection: '專利條款',
                guidelineSource: '指南來源',
                dimensionId: '維度編號',
                statute: '法規',
                issueType: '問題類型',
            },
        },
        errors: {
            createTaskFailed: '創建核稿任務失敗，請重試',
            loadTaskFailed: '加載任務狀態失敗，請重試',
            loadReportFailed: '加載核稿報告失敗，請重試',
            loadTasksFailed: '加載任務列表失敗，請重試',
            unsupportedOffice: '暫不支援該受理局',
            exportReportFailed: '導出核稿報告失敗，請重試',
        },
    },
};
